export const SELECT_FILTER_STYLE = {
    control: (base) => ({
        ...base,
        minHeight: '31px',
        height: '31px',
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '0 6px',
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: '31px',
    }),
};
  
export const BUILT_IN_REPORT_FILTERS = {
    dateRange: {
        id: 'dateRange',
        type: 'dateRange',
        section: 'primary',
        col: 2,
    },
  
    loanPurpose: {
        id: 'loanPurpose',
        label: 'Loan Purpose',
        field: 'purpose',
        type: 'multiSelect',
        optionKey: 'loanPurpose',
        operator: 'in',
        section: 'primary',
        col: 2,
    },
  
    loanType: {
        id: 'loanType',
        label: 'Loan Type',
        field: 'type',
        type: 'multiSelect',
        optionKey: 'loanType',
        operator: 'in',
        section: 'primary',
        col: 2,
    },
  
    loanSource: {
        id: 'loanSource',
        label: 'Loan Source',
        field: 'source',
        type: 'multiSelect',
        optionKey: 'loanSource',
        operator: 'in',
        section: 'primary',
        col: 2,
    },
  
    referralSource: {
        id: 'referralSource',
        label: 'Referred By',
        field: 'referralSource',
        type: 'multiSelect',
        optionKey: 'referralSource',
        operator: 'in',
        section: 'advanced',
        col: 2,
    },
  
    city: {
        id: 'city',
        label: 'City',
        field: 'city',
        type: 'multiSelect',
        optionKey: 'cities',
        operator: 'in',
        section: 'advanced',
        col: 2,
    },
  
    state: {
        id: 'state',
        label: 'State',
        field: 'state',
        type: 'multiSelect',
        optionKey: 'states',
        operator: 'in',
        section: 'advanced',
        col: 2,
    },
  
    zip: {
        id: 'zip',
        label: 'Zip',
        field: 'zip',
        type: 'multiSelect',
        optionKey: 'zips',
        operator: 'in',
        section: 'advanced',
        col: 2,
    },
  
    county: {
        id: 'county',
        label: 'County',
        field: 'county',
        type: 'multiSelect',
        optionKey: 'counties',
        operator: 'in',
        section: 'advanced',
        col: 2,
    },
  
    purchasePrice: {
        id: 'purchasePrice',
        label: 'Purchase $',
        field: 'purchasePrice',
        type: 'numberRange',
        minKey: 'minPurchasePrice',
        maxKey: 'maxPurchasePrice',
        minLabel: 'Min Purchase $',
        maxLabel: 'Max Purchase $',
        section: 'advanced',
        col: 2,
    },
  
    minPurchasePrice: {
        extends: 'purchasePrice',
    },
  
    loanAmount: {
        id: 'loanAmount',
        label: 'Loan $',
        field: 'loanAmount',
        type: 'numberRange',
        minKey: 'minLoanAmount',
        maxKey: 'maxLoanAmount',
        minLabel: 'Min Loan $',
        maxLabel: 'Max Loan $',
        section: 'advanced',
        col: 2,
    },
  
    minLoanAmount: {
        extends: 'loanAmount',
    },
  
    interestRate: {
        id: 'interestRate',
        label: 'Interest Rate',
        field: 'interestRate',
        type: 'numberRange',
        minKey: 'minInterestRate',
        maxKey: 'maxInterestRate',
        minLabel: 'Min Interest Rate (%)',
        maxLabel: 'Max Interest Rate (%)',
        section: 'advanced',
        col: 2,
    },
  
    minInterestRate: {
        extends: 'interestRate',
    },
  
    conversionMilestones: {
        id: 'conversionMilestones',
        label: 'Conversion Milestones',
        field: 'conversionMilestones',
        type: 'multiSelect',
        optionKey: 'conversionMilestones',
        operator: 'in',
        section: 'advanced',
        col: 2,
    },
};
  
export function normalizeReportFilters(reportConfig = {}) {
    const rawFilters = reportConfig.filters || [];
  
    const normalized = rawFilters.map((filter) => {
        if (typeof filter === 'string') {
            const builtIn = BUILT_IN_REPORT_FILTERS[filter];
    
            if (!builtIn) {
                console.warn(`Unknown report filter: ${filter}`);
                return null;
            }
    
            if (builtIn.extends) {
                return BUILT_IN_REPORT_FILTERS[builtIn.extends];
            }
    
            return builtIn;
        }
    
        return {
            section: 'advanced',
            col: 2,
            operator: filter.type === 'multiSelect' ? 'in' : undefined,
            ...filter,
        };
    }).filter(Boolean);
  
    return dedupeFilters(normalized);
}
  
function dedupeFilters(filters) {
    const seen = new Set();
  
    return filters.filter((filter) => {
        if (seen.has(filter.id)) return false;
        seen.add(filter.id);
        return true;
    });
}